import { render, staticRenderFns } from "./form-empty.vue?vue&type=template&id=63663f62&scoped=true&"
import script from "./form-empty.vue?vue&type=script&lang=js&"
export * from "./form-empty.vue?vue&type=script&lang=js&"
import style0 from "./form-empty.vue?vue&type=style&index=0&id=63663f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63663f62",
  null
  
)

export default component.exports